import React, { useState, useEffect } from "react";
import { Card, Form, Button, Alert, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IconSettings } from "@tabler/icons-react";
import { Helmet } from "react-helmet-async";

const Settings = () => {
  const [settings, setSettings] = useState({
    // системные
    max_redirects: 3,
    minutes_between_redirects: 60,
    minutes_between_checks: 180,
    max_index_wait_hours: 168,
    api_keys: "key:cx",

    // A-Parser: доступ/пресеты
    aparser_api: "http://134.122.93.6:9091/API",
    aparser_pass: "LxjEkvDl4lkwQ23kj4odfXld4#q",
    aparser_parser: "SE::Google",
    aparser_preset: "тест100",
    aparser_config: "Ihor don't touch",

    // A-Parser: таймауты/ретраи/фейловер
    aparser_http_timeout: 60,
    aparser_soft_limit: 75,
    aparser_hard_limit: 90,
    aparser_max_retries: 3,
    aparser_failover_enabled: false,
    aparser_failover_config: ""
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch("/api/settings", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Ошибка загрузки настроек");
        const data = await res.json();
        setSettings((prev) => ({
          ...prev,
          ...data,
           api_keys: data.api_keys || "",
           index_check_provider: data.index_check_provider || "aparser",
           aparser_api: data.aparser_api || prev.aparser_api,
           aparser_pass: data.aparser_pass || prev.aparser_pass,
           aparser_parser: data.aparser_parser || prev.aparser_parser,
           aparser_preset: data.aparser_preset || prev.aparser_preset,
           aparser_config: data.aparser_config || prev.aparser_config,
           aparser_http_timeout: data.aparser_http_timeout ?? prev.aparser_http_timeout,
           aparser_soft_limit: data.aparser_soft_limit ?? prev.aparser_soft_limit,
           aparser_hard_limit: data.aparser_hard_limit ?? prev.aparser_hard_limit,
           aparser_max_retries: data.aparser_max_retries ?? prev.aparser_max_retries,
           aparser_failover_enabled: data.aparser_failover_enabled ?? prev.aparser_failover_enabled,
           aparser_failover_config: data.aparser_failover_config ?? prev.aparser_failover_config,
         }));
      } catch (e) {
        console.error(e);
        setError("Не удалось загрузить настройки");
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setSettings((s) => ({
      ...s,
      [name]:
        type === "number"
          ? (value === "" ? "" : Number(value))
          : value,
    }));
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setSettings((s) => ({ ...s, [name]: checked }));
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/settings", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(settings),
      });
      if (!res.ok) throw new Error("Ошибка сохранения");
      setMessage("Настройки успешно сохранены");
      setTimeout(() => setMessage(""), 3000);
    } catch (e) {
      console.error(e);
      setError("Не удалось сохранить");
      setTimeout(() => setError(""), 3000);
    }
  };

  return (
    <>
      <Helmet><title>Admin Settings - IndexBooster</title></Helmet>
      <Card>
        <Card.Header className="d-flex align-items-center gap-2">
          <IconSettings size={22} />
          <h3 className="mb-0">Системные настройки</h3>
        </Card.Header>
        <Card.Body>
          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form>
            {/* Блок: базовые системные параметры */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Сколько раз редиректить бота</Form.Label>
                  <Form.Control
                    type="number"
                    name="max_redirects"
                    value={settings.max_redirects}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Пауза между редиректами (мин)</Form.Label>
                  <Form.Control
                    type="number"
                    name="minutes_between_redirects"
                    value={settings.minutes_between_redirects}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Пауза между проверками индексации (мин)</Form.Label>
                  <Form.Control
                    type="number"
                    name="minutes_between_checks"
                    value={settings.minutes_between_checks}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Через сколько часов вернуть кредит</Form.Label>
                  <Form.Control
                    type="number"
                    name="max_index_wait_hours"
                    value={settings.max_index_wait_hours}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-4">
              <Form.Label>Google API ключи (format: key:cx per line)</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="api_keys"
                value={settings.api_keys}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Блок: A-Parser Settings */}
            <Card className="mb-3">
              <Card.Header><strong>A-Parser Settings</strong></Card.Header>
              <Card.Body>
                <Row>
                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label>API URL</Form.Label>
                      <Form.Control
                        type="text"
                        name="aparser_api"
                        value={settings.aparser_api || ""}
                        onChange={handleChange}
                        placeholder="http://134.122.93.6:9091/API"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Parser</Form.Label>
                      <Form.Control
                        type="text"
                        name="aparser_parser"
                        value={settings.aparser_parser || ""}
                        onChange={handleChange}
                        placeholder="SE::Google"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Preset (профиль парсера)</Form.Label>
                      <Form.Control
                        type="text"
                        name="aparser_preset"
                        value={settings.aparser_preset || ""}
                        onChange={handleChange}
                        placeholder="тест100"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Config preset</Form.Label>
                      <Form.Control
                        type="text"
                        name="aparser_config"
                        value={settings.aparser_config || ""}
                        onChange={handleChange}
                        placeholder="Ihor don't touch"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>API Password</Form.Label>
                  <Form.Control
                    type="text"
                    name="aparser_pass"
                    value={settings.aparser_pass || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>HTTP timeout (sec)</Form.Label>
                      <Form.Control
                        type="number"
                        name="aparser_http_timeout"
                        value={settings.aparser_http_timeout ?? 60}
                        onChange={handleChange}
                        min={5}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Soft time limit (sec)</Form.Label>
                      <Form.Control
                        type="number"
                        name="aparser_soft_limit"
                        value={settings.aparser_soft_limit ?? 75}
                        onChange={handleChange}
                        min={10}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Hard time limit (sec)</Form.Label>
                      <Form.Control
                        type="number"
                        name="aparser_hard_limit"
                        value={settings.aparser_hard_limit ?? 90}
                        onChange={handleChange}
                        min={20}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Max retries</Form.Label>
                      <Form.Control
                        type="number"
                        name="aparser_max_retries"
                        value={settings.aparser_max_retries ?? 3}
                        onChange={handleChange}
                        min={0}
                      />
                    </Form.Group>
                  </Col>
                </Row>
<Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Index check provider</Form.Label>
      <Form.Select
        name="index_check_provider"
        value={settings.index_check_provider || "aparser"}
        onChange={handleChange}
      >
        <option value="aparser">A-Parser</option>
        <option value="google">Google Search API</option>
      </Form.Select>
    </Form.Group>
  </Col>
</Row>
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Check
                        type="checkbox"
                        label="Failover включен"
                        name="aparser_failover_enabled"
                        checked={!!settings.aparser_failover_enabled}
                        onChange={handleCheckbox}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label>Failover config preset</Form.Label>
                      <Form.Control
                        type="text"
                        name="aparser_failover_config"
                        value={settings.aparser_failover_config || ""}
                        onChange={handleChange}
                        placeholder="например, Booster-Fallback"
                        disabled={!settings.aparser_failover_enabled}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Button variant="primary" onClick={handleSave}>
              Сохранить
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default Settings;
